import { ColorTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, IconTokens, SizeTypeTokens, StackAlignItems, StackJustifyContent, StackType, StackWidth, WIDGET } from "@voltmoney/schema";
export const ActiveCustomerMobEmptyStateStack = async () => {
    const DS = {
        activeCustomerMobEmptyStateStack: {
            type: StackType.column,
            width: StackWidth.MATCH_PARENT,
            justifyContent: StackJustifyContent.center,
            alignItems: StackAlignItems.center,
            padding: {
                top: SizeTypeTokens.XXXXL
            },
            widgetItems: [
                { id: 'activeCustomerMobEmptyStateIcon', type: WIDGET.ICON },
                { id: 'activeCustomerMobEmptyStateStackSpace0', type: WIDGET.SPACE },
                { id: 'activeCustomerMobEmptyStateStackT1', type: WIDGET.TEXT },
                { id: 'activeCustomerMobEmptyStateStackSpace1', type: WIDGET.SPACE },
            ]
        },
        activeCustomerMobEmptyStateIcon: {
            name: IconTokens.List,
            size: IconSizeTokens.XXXXXXXXL,
        },
        activeCustomerMobEmptyStateStackT1: {
            label: 'No active customers found',
            textAlign: 'center',
            fontFamily: FontFamilyTokens.Poppins,
            fontSize: FontSizeTokens.XXL,
            fontWeight: '600',
            lineHeight: 32,
            color: ColorTokens.Grey_Night
        },
        activeCustomerMobEmptyStateStackSpace0: {
            size: SizeTypeTokens.MD
        },
        activeCustomerMobEmptyStateStackSpace1: {
            size: SizeTypeTokens.XL
        },
        activeCustomerMobEmptyStateStackSpace2: {
            size: SizeTypeTokens.XL
        },
    };
    return DS;
};
